module.exports = __webpack_public_path__ + "img/classificationDegrees.dc695489.svg";